import { render, staticRenderFns } from "./Bi-Access.vue?vue&type=template&id=b92ee3a8&"
import script from "./Bi-Access.vue?vue&type=script&lang=js&"
export * from "./Bi-Access.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports